module.exports = __webpack_public_path__ + "img/news-03.67c8c434.png";